module.exports = __webpack_public_path__ + "img/logo_rvs.3019c9b7.svg";